<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-evgImport-usfsInventoryData',
  components: { PageTable },
}
</script>
